import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/projects/{id}', 'delete'>;
type ResponseBody = OASOutput<O, '/api/projects/{id}', 'delete'>;

type Params = {
  id: number;
};

type Result = {
  id: number;
};

export const deleteProjectFactory = (apiClient: ApiClient) => {
  const deleteProject = async (id: number) => {
    const requestBody = mapInputToRequestBody({ id });
    const response = await apiClient['/api/projects/{id}'].delete(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      params: {
        id: input.id,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      id: response,
    };
  };

  return deleteProject;
};
